(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["king-studio"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const initialized = window.__kingStudioInitialized || new WeakSet();
  window.__kingStudioInitialized = initialized;
  function init(section) {
    if (initialized.has(section)) return;
    const frame = section.querySelector('[data-king-frame]');
    const productNode = section.querySelector('[data-king-product]');
    const status = section.querySelector('[data-king-status]');
    if (!frame || !productNode) return;
    initialized.add(section);
    let editor, product;
    try {
      editor = new URL(section.dataset.editorUrl);
      if (editor.protocol !== 'https:') throw new Error('The editor URL must use HTTPS.');
      product = JSON.parse(productNode.textContent);
    } catch (error) { status.textContent = error.message; return; }
    const instance = crypto.randomUUID();
    const mode = ['gang', 'shirt', 'sticker', 'sublimation'].includes(section.dataset.mode) ? section.dataset.mode : 'gang';
    const checkoutEnabled = section.dataset.checkoutEnabled === 'true';
    const mirrorPrint = section.dataset.mirrorPrint === 'true';
    const defaultWidth = Number(section.dataset.width) || 22;
    const defaultHeight = Number(section.dataset.height) || 24;
    const variants = (Array.isArray(product.variants) ? product.variants : []).map(v => {
      const match = String(v.title).match(/(\d+(?:\.\d+)?)\s*["″]?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
      return { id: v.id, title: v.title, available: v.available, price: v.price,
        width: mode === 'shirt' ? 12 : match ? Number(match[1]) : defaultWidth,
        height: mode === 'shirt' ? 16 : match ? Number(match[2]) : defaultHeight,
        options: v.options };
    });
    const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
    const initialVariant = variants.find(variant => String(variant.id) === requestedVariantId && variant.available);
    const orderedVariants = initialVariant ? [initialVariant, ...variants.filter(variant => variant.id !== initialVariant.id)] : variants;
    const config = { instance, title: product.title || section.dataset.title || 'DTF King Studio', mode,
      designOnly: !checkoutEnabled || !variants.length, width: initialVariant?.width || defaultWidth, height: initialVariant?.height || defaultHeight, mirrorPrint,
      currency: section.dataset.currency || 'USD', variants: orderedVariants,
      optionNames: (Array.isArray(product.options) ? product.options : []).map(v => typeof v === 'string' ? v : v.name) };
    editor.searchParams.set('embed', '1');
    editor.searchParams.set('parent_origin', window.location.origin);
    editor.searchParams.set('instance', instance);
    const origin = editor.origin;
    const root = window.Shopify?.routes?.root || '/';
    const completed = new Map();
    let pending = null;
    let uncertain = null;
    const reply = payload => frame.contentWindow?.postMessage({ ...payload, instance }, origin);
    const isURL = value => typeof value === 'string' && /^(https?:\/\/|\/\/|\/uploads\/)/i.test(value);
    const attachmentOK = f => f && f.blob instanceof Blob && f.blob.size > 0 && f.blob.size <= 20000000 && ['image/png', 'application/zip'].includes(f.blob.type) && typeof f.name === 'string' && f.name.length <= 160;
    async function pngSize(file) {
      const buf = await file.slice(0, 24).arrayBuffer();
      if (buf.byteLength < 24) throw new Error('The print PNG is incomplete.');
      const bytes = new Uint8Array(buf), view = new DataView(buf);
      if (bytes[0] !== 137 || bytes[1] !== 80 || bytes[2] !== 78 || bytes[3] !== 71) throw new Error('Invalid print PNG.');
      return [view.getUint32(16), view.getUint32(20)];
    }
    async function validate(data) {
      if (!/^[a-f0-9-]{36}$/i.test(data.requestId || '')) throw new Error('Invalid request identifier.');
      if (config.designOnly) throw new Error('Ordering is not available for this transfer product yet.');
      const variant = variants.find(v => v.id === data.variantId);
      if (!variant?.available) throw new Error('This product variant is unavailable.');
      if (!Number.isInteger(data.quantity) || data.quantity < 1 || data.quantity > 999) throw new Error('Choose a quantity between 1 and 999.');
      if (!Array.isArray(data.files) || data.files.length < 1 || data.files.length > (mode === 'shirt' ? 2 : 1) || !data.files.every(attachmentOK)) throw new Error('Print files are missing, unsupported, or over 20 MB.');
      if (!(data.proof instanceof Blob) || data.proof.type !== 'image/png' || data.proof.size > 5000000 || !data.proof.size) throw new Error('The design proof is missing or too large.');
      const sides = new Set();
      for (const file of data.files) {
        if (mode === 'shirt' && (!['Front', 'Back'].includes(file.side) || sides.has(file.side))) throw new Error('Shirt print sides are invalid.');
        sides.add(file.side);
        if (file.blob.type === 'image/png') {
          const [w, h] = await pngSize(file.blob);
          if (Math.abs(w - Math.ceil(variant.width * 300)) > 1 || Math.abs(h - Math.ceil(variant.height * 300)) > 1) throw new Error('Artwork size does not match the selected variant.');
        } else {
          const bytes = new Uint8Array(await file.blob.slice(0, 4).arrayBuffer());
          if (bytes[0] !== 80 || bytes[1] !== 75 || bytes[2] !== 3 || bytes[3] !== 4) throw new Error('Invalid panel archive.');
        }
      }
      return variant;
    }
    async function recoverRequest(requestId) {
      const r = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) throw new Error('Could not verify the cart. Check the cart before retrying.');
      const cart = await r.json();
      return cart.items.find(line => line.properties?.['_King request'] === requestId);
    }
    const onMessage = async event => {
      if (event.origin !== origin || event.source !== frame.contentWindow || event.data?.instance !== instance) return;
      const data = event.data;
      if (data.type === 'KING_READY') { reply({ type: 'KING_CONFIG', config }); return; }
      if (data.type !== 'KING_ADD_TO_CART') return;
      if (completed.has(data.requestId)) { reply(completed.get(data.requestId)); return; }
      if (pending) { reply({ type: 'KING_CART_RESULT', requestId: data.requestId, ok: false, error: 'An order request is already processing. Please wait.' }); return; }
      pending = data.requestId;
      let line, expected = [], posted = false;
      try {
        const variant = await validate(data);
        if (uncertain) {
          const recovered = await recoverRequest(uncertain);
          if (recovered) throw new Error('Your previous design is already in the cart. Check the cart before adding another.');
          throw new Error('Your earlier request is still unconfirmed. Reload the storefront and check the cart before retrying.');
        }
        status.textContent = 'Uploading your design and print files to Shopify…';
        const form = new FormData();
        form.set('id', String(variant.id));
        form.set('quantity', String(data.quantity));
        form.set('properties[_King request]', data.requestId);
        form.set('properties[_King builder]', 'DTF King Studio 1.1');
        form.set('properties[Transfer type]', { gang: 'DTF Transfers', sticker: 'DTF Stickers', sublimation: 'Sublimation Transfers', shirt: 'Shirt builder' }[mode]);
        form.set('properties[Print orientation]', mirrorPrint ? 'Mirrored' : 'Unmirrored');
        for (const key of ['Design', 'Print area', 'Artwork count', 'Mode']) {
          const value = data.properties?.[key];
          if (typeof value === 'string' && value.length <= 180) form.set(`properties[${key}]`, value);
        }
        data.files.forEach((file, index) => {
          const key = `_King print file ${index + 1}`;
          expected.push(key);
          form.set(`properties[${key}]`, file.blob, file.name.replace(/[^a-zA-Z0-9_.-]/g, '-'));
          form.set(`properties[_King print side ${index + 1}]`, String(file.side || 'Sheet').slice(0, 40));
        });
        expected.push('_King proof');
        form.set('properties[_King proof]', data.proof, 'king-design-proof.png');
        posted = true;
        const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', body: form });
        const result = await response.json();
        if (!response.ok) { posted = false; throw new Error(result.description || result.message || 'Shopify could not add this design.'); }
        line = result.items?.[0] || result;
        if (!line.key || line.properties?.['_King request'] !== data.requestId) line = await recoverRequest(data.requestId);
        if (!line || expected.some(key => !isURL(line.properties?.[key]))) {
          if (line?.key) {
            const cleanup = await fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: line.key, quantity: 0 }) });
            if (!cleanup.ok) throw new Error('Print attachments were not confirmed. Remove the incomplete design from your cart before checkout.');
          }
          posted = false;
          throw new Error('Shopify did not retain every print attachment. The incomplete item was removed. Verify file-property support on this theme before launch.');
        }
        const resultMessage = { type: 'KING_CART_RESULT', requestId: data.requestId, ok: true };
        completed.set(data.requestId, resultMessage);
        reply(resultMessage);
        status.textContent = 'Your design and print files were added to the cart.';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (section.dataset.redirectCart === 'true') location.assign(root + 'cart');
      } catch (error) {
        if (posted) uncertain = data.requestId;
        const message = error instanceof Error ? error.message : 'Could not add the design. Check your cart before retrying.';
        status.textContent = message;
        reply({ type: 'KING_CART_RESULT', requestId: data.requestId, ok: false, error: message });
      } finally { pending = null; }
    };
    window.addEventListener('message', onMessage);
    frame.src = editor.href;
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(section)) window.removeEventListener('message', onMessage);
    });
  }
  const start = () => document.querySelectorAll('[data-king-studio]').forEach(init);
  start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["royal-interactive"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.classList.add('ri-ready');
    const controller = new AbortController();
    root.royalCleanup = () => controller.abort();
    const signal = controller.signal;
    const range = root.querySelector('[data-ri-range]');
    const compare = root.querySelector('[data-ri-compare]');
    range.addEventListener('input', () => compare.style.setProperty('--ri-split', `${range.value}%`), { signal });
    const scenes = Array.from(root.querySelectorAll('[data-ri-scene]'));
    const full = root.querySelector('[data-ri-full]');
    const detail = root.querySelector('[data-ri-detail]');
    const dialog = root.querySelector('[data-ri-dialog]');
    const lightbox = root.querySelector('[data-ri-lightbox-image]');
    const caption = root.querySelector('[data-ri-caption]');
    let sceneIndex = 0;
    let galleryTrigger;
    function showScene(index) {
      sceneIndex = (index + scenes.length) % scenes.length;
      const scene = scenes[sceneIndex];
      scenes.forEach(button => button.setAttribute('aria-pressed', String(button === scene)));
      full.src = scene.dataset.src;
      full.alt = scene.dataset.alt;
      detail.src = scene.dataset.src;
      lightbox.src = scene.dataset.src;
      lightbox.alt = scene.dataset.alt;
      caption.textContent = `${String(sceneIndex + 1).padStart(2, '0')} / ${String(scenes.length).padStart(2, '0')} · ${scene.dataset.caption}`;
    }
    scenes.forEach((button, index) => button.addEventListener('click', () => showScene(index), { signal }));
    root.querySelector('[data-ri-open]').addEventListener('click', event => {
      if (typeof dialog.showModal !== 'function') return;
      galleryTrigger = event.currentTarget;
      showScene(sceneIndex);
      dialog.showModal();
      document.body.classList.add('modal-open');
    }, { signal });
    root.querySelector('[data-ri-close]').addEventListener('click', () => dialog.close(), { signal });
    root.querySelector('[data-ri-previous]').addEventListener('click', () => showScene(sceneIndex - 1), { signal });
    root.querySelector('[data-ri-next]').addEventListener('click', () => showScene(sceneIndex + 1), { signal });
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    }, { signal });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        showScene(sceneIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }, { signal });
    dialog.addEventListener('close', () => { document.body.classList.remove('modal-open'); galleryTrigger?.focus(); }, { signal });
    const tablist = root.querySelector('[data-ri-tablist]');
    const tabs = Array.from(tablist.querySelectorAll('[role=tab]'));
    const panels = Array.from(root.querySelectorAll('[data-ri-panel]'));
    function selectTab(tab, animate = true) {
      tabs.forEach(button => {
        const selected = button === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        panel.hidden = !selected;
        panel.classList.remove('ri-panel-enter');
        if (selected && animate) panel.classList.add('ri-panel-enter');
      });
    }
    tabs.forEach(tab => {
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      tab.addEventListener('click', () => selectTab(tab), { signal });
      tab.addEventListener('keydown', event => {
        let next = tabs.indexOf(tab);
        if (event.key === 'ArrowRight') next = (next + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (next - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectTab(tabs[next]);
        tabs[next].focus();
      }, { signal });
    });
    if (tabs.length) { selectTab(tabs[0], false); tablist.hidden = false; }
    panels.forEach(panel => {
      const select = panel.querySelector('[data-ri-size]');
      const price = panel.querySelector('[data-ri-price]');
      const link = panel.querySelector('[data-ri-order-link]');
      if (!select || !price) return;
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        price.textContent = option.dataset.price;
        if (link) {
          const url = new URL(link.dataset.baseUrl, window.location.origin);
          url.searchParams.set('variant', option.value);
          const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewId) url.searchParams.set('preview_theme_id', previewId);
          link.href = url.toString();
        }
      }, { signal });
    });
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let revealObserver;
    if (!reduced.matches && 'IntersectionObserver' in window) {
      root.classList.add('ri-motion');
      revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('ri-visible'); revealObserver.unobserve(entry.target); }
      }), { threshold: 0.08 });
      root.querySelectorAll('.ri-reveal').forEach(node => revealObserver.observe(node));
    }
    reduced.addEventListener('change', event => { if (event.matches) { root.classList.remove('ri-motion'); revealObserver?.disconnect(); } }, { signal });
    const progress = root.querySelector('[data-ri-progress]');
    let scheduled = false;
    function updateProgress() {
      scheduled = false;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0})`;
    }
    window.addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateProgress); } }, { passive: true, signal });
    window.addEventListener('resize', updateProgress, { passive: true, signal });
    updateProgress();
    signal.addEventListener('abort', () => { revealObserver?.disconnect(); if (dialog.open) dialog.close(); });
  }
  document.querySelectorAll('[data-royal-experience]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-royal-experience]').forEach(init));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-royal-experience]').forEach(root => root.royalCleanup?.()));
})();

  } catch(e) { console.error(e); }
})();
})();
